import React from "react";
import { parseActivityType } from "planEditor/types/Activity";

export enum BadgeRank {
    None = 0,
    Bronze = 1,
    Silver = 2,
    Gold = 3
}

export const getBadgeLevel = (rank: number): string => {
    if (rank >= 3) {
        return BadgeRank.Gold.toString();
    }

    let badgeLevel: string = BadgeRank.None.toString();
    for (const key in BadgeRank) {
        if (rank === Number(BadgeRank[key])) {
            badgeLevel = key.toString();
            break;
        }

    }

    return badgeLevel;
};

export const getActivityBadgeImagePath = (
    activityType: string,
    rank: number
): string => {
    return `/icons/rewardData/${parseActivityType(activityType)}Activity_${getBadgeLevel(rank)}.png`;
};

export const renderActivityBadgeImage = (
    activityType: string,
    rank: number,
    width: number,
    height: number
): React.JSX.Element => {
    return (
        <img
            className={`w-${width} h-${height}`}
            src={getActivityBadgeImagePath(activityType, rank)}
            alt="badge"
        />
    );
};

export const getCoachingPlanWeekBadgeImagePath = (
    rank: number = 0,
    week: number = 0
): string => {
    if (rank > 0 && week > 0) {
        return `/icons/badges/CoachingPlan_${getBadgeLevel(rank)}${week <= 12 ? `_Week_${week}` : ""}.png`;
    }
    else {
        return "/icons/badges/CoachingPlan_None.png";
    }
};

export const getVisitBadgeImagePath = (badge) => {
    if (badge === undefined) {
        return "/icons/badges/Session_None.png";
    }

    switch (badge) {
        case badge.includes("1x"):
            return "/icons/badges/Session_Bronze.png";
        case badge.includes("2x"):
            return "/icons/badges/Session_Silver.png";
        case badge.includes("3x"):
            return "/icons/badges/Session_Gold.png";
        default:
            return "/icons/badges/Session_None.png";
    }
};